import React, { useEffect, useState } from "react";
import ProfilePage from "./ProfilePage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faXmark } from "@fortawesome/free-solid-svg-icons";

export default function SettingsMenu(props) {
  const [active, setActive] = useState(null);

  const SettingsHeader = () => {
    return (
      <div style={{ width: "100%", textAlign: "left" }}>
        <FontAwesomeIcon
          icon={faArrowLeft}
          size="2xl"
          onClick={() => setActive(null)}
        />
      </div>
    );
  };
  return (
    <div className="NavMenuContainer">
      <div onClick={() => props.setShow(false)} style={{ width: "100%" }}></div>
      <div className="SettingsPage">
        {active ? (
          <>
            <SettingsHeader />
            {active}
          </>
        ) : (
          <>
            <div style={{ width: "100%", textAlign: "right" }}>
              <FontAwesomeIcon
                icon={faXmark}
                size="2xl"
                onClick={() => props.setShow(false)}
              />
            </div>
            <div style={{ marginTop: "10vh" }}>
              <h1 style={{ marginBottom: "50px" }}>Inställningar</h1>
              <h2
                className="nav hoverButton"
                onClick={() => setActive(<ProfilePage />)}
              >
                Profil
              </h2>
              <h2
                className="mav hoverButton"
                onClick={() =>
                  (window.location.href =
                    "mailto:artic@redata.se?subject=Felanmälan&body=Fyll i anmälan%20här")
                }
              >
                Felanmäl
              </h2>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
